var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWordpress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wordpress 2",
    clipPath: "url(#clip0_97_602)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.16593 7.71549H6.78535L10.5492 18.355L12.6563 12.3336L11.0226 7.71549H9.566V6.70169H16.0165V7.71549H14.5059L18.2697 18.355L19.6226 14.4887C21.3974 9.53517 18.168 7.99214 18.168 6.88665C18.168 5.78116 19.0642 4.88502 20.1696 4.88502C20.2295 4.88502 20.2875 4.88826 20.3444 4.89357C18.4714 3.12537 15.9457 2.04105 13.1666 2.04105C9.53517 2.04105 6.33647 3.89206 4.46133 6.70169H8.16582V7.71549H8.16593Z",
    fill: "#00769D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.70764 12.5C2.70764 16.5043 4.95827 19.9824 8.26319 21.7399L3.54324 8.39767C3.00557 9.6573 2.70764 11.0439 2.70764 12.5Z",
    fill: "#00769D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.269 7.34619C22.4186 8.22708 22.3733 9.21714 22.1438 10.2111H22.1854L22.0272 10.6629C21.9335 10.9892 21.8155 11.323 21.6815 11.651L18.0827 21.7332C21.3807 19.9735 23.6255 16.4992 23.6255 12.5C23.6255 10.626 23.1322 8.86744 22.269 7.34619Z",
    fill: "#00769D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.94098 22.4513C10.9571 22.7804 12.0409 22.959 13.1667 22.959C14.2404 22.959 15.2763 22.7969 16.2514 22.4963L13.1921 13.8481L9.94098 22.4513Z",
    fill: "#00769D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.0055 3.66121C19.6445 1.30028 16.5055 6.10352e-05 13.1666 6.10352e-05C9.82773 6.10352e-05 6.68873 1.30028 4.3278 3.66121C1.96688 6.02213 0.666656 9.16114 0.666656 12.5001C0.666656 15.8389 1.96688 18.9779 4.3278 21.3389C6.68873 23.6998 9.82779 25 13.1667 25C16.5055 25 19.6445 23.6998 22.0055 21.3389C24.3664 18.9779 25.6667 15.8389 25.6667 12.5001C25.6666 9.16114 24.3664 6.02213 22.0055 3.66121ZM13.1666 24.1182C6.76032 24.1182 1.54844 18.9063 1.54844 12.5001C1.54844 6.09378 6.76032 0.881841 13.1666 0.881841C19.5729 0.881841 24.7848 6.09378 24.7848 12.5001C24.7848 18.9063 19.5729 24.1182 13.1666 24.1182Z",
    fill: "#00769D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_97_602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.666656 6.10352e-05)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordpress);
export default __webpack_public_path__ + "static/media/wordpress.3077ead5e051a1d195d15e42d0bfa69c.svg";
export { ForwardRef as ReactComponent };